export const DOMAIN_COUNTRY = {
  ru: 'Россия',
  kg: 'Кыргызстан',
  com: 'Казахстан',
} as const

export const DEFAULT_COUNTRY_TLD = 'ru'
